import { render, staticRenderFns } from "./AdminNotBookedReports.vue?vue&type=template&id=2db6e19e"
import script from "./AdminNotBookedReports.vue?vue&type=script&lang=js"
export * from "./AdminNotBookedReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports